export const CASTLE_DEVICE_LIMIT_RULE = "castle_disposable_and_device_accounts_v1";

export type CastleTrialDeviceLimit = {
  ruleVersion: typeof CASTLE_DEVICE_LIMIT_RULE;
  restricted: boolean;
  usersPerDevice: number;
  disposableEmailDenied: boolean;
  source: "filter";
  evaluatedAt: Date;
  threshold: number;
};

export function castleDeviceAccountCount(result: unknown): number | null {
  const value = (result as { metrics?: { users_per_device_fingerprint?: { value?: unknown } } } | null)
    ?.metrics?.users_per_device_fingerprint?.value;
  return typeof value === "number" && Number.isSafeInteger(value) && value >= 0 ? value : null;
}

export function hasCastleDisposableEmailDenial(result: unknown): boolean {
  const policy = (result as { policy?: { name?: unknown; action?: unknown } } | null)?.policy;
  return policy?.name === "Deny Disposable Emails" && policy?.action === "deny";
}
